import builder from '../builder';
import CommonFileDouble from '../../streamline-icons/light/common-file-double.svg';

export default builder('IconCommonFileDoubleLight', CommonFileDouble);
